"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.cloneFromTemplateArtifact = void 0;
const uuid_1 = require("uuid");
const tape_builder_base_1 = require("../../types/tape-builder-base");
const cloneUtils_1 = require("../cloneUtils");
const node_1 = require("./node");
const cloneConfig = ({ config, cloneMap, }) => ({
    // The config is a TapeBuilderTask operation plus the required `passThrough`
    // flag. Schema-driven remap rewrites its branded source-input slug references
    // (previously dropped on clone).
    ...(0, tape_builder_base_1.remapArtifactSlugRefs)(node_1.NodeConfigSchema, config, (slug) => (0, cloneUtils_1.getClonedArtifactSlug)(slug, cloneMap)),
    // A cloned node must preserve the SOURCE's behavior: an un-migrated source
    // (flag absent) historically behaved as pass-through, so default to true.
    passThrough: config.passThrough ?? true,
});
const cloneFromTemplateArtifact = ({ artifactToClone, newArtifactDocumentId, cloneMap, }) => ({
    artifactSlug: (0, cloneUtils_1.getClonedArtifactSlug)(artifactToClone.artifactSlug, cloneMap),
    artifactDocumentId: newArtifactDocumentId,
    creditFacilitySlug: (0, cloneUtils_1.getClonedSlug)(artifactToClone.creditFacilitySlug, cloneMap),
    loanProductSlug: (0, cloneUtils_1.getClonedSlug)(artifactToClone.loanProductSlug, cloneMap),
    externalFilename: null,
    id: (0, uuid_1.v4)(),
    type: node_1.artifactType,
    configuration: cloneConfig({
        config: artifactToClone.configuration,
        cloneMap,
    }),
});
exports.cloneFromTemplateArtifact = cloneFromTemplateArtifact;
//# sourceMappingURL=clone.js.map